import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import Stepper from 'bs-stepper';
import { Constants } from 'app/shared/constant/constants';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { InputPatterns } from 'app/shared/helper/input-patterns';
import { ToastrService } from 'ngx-toastr';
import { Step02Data, StepperDataModel } from 'app/modules/remittance/models/stepperdata.model';
import { Router } from '@angular/router';
import { AddRelationshipModel } from 'app/modules/relationship/models/relationship.model';
import { RelationshipService } from 'app/modules/relationship/services/relationship.service';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { ViewLocalFileUtils } from 'app/shared/utility/view-local-file-utils';

@Component({
  selector: 'list-relationship-stepper',
  templateUrl: './list-relationship-stepper.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ListRelationshipStepperComponent implements OnInit {

  private horizontalWizardStepper: Stepper;
  public showAddRelationSection = false;
  public relationshipMemberListItems: any;
  public getRelationShipList = Constants.payerList;
  public consumerId: any;
  public stepperDataModel: StepperDataModel = new StepperDataModel();

  public addRelationshipModel = new AddRelationshipModel();
  public showAddRelationForm: boolean = false;
  public step02Data: Step02Data = new Step02Data();
  public alphabetsSpacePattern = InputPatterns.ALPHABETS_SPACE_PATTERN;
  public panPattern = InputPatterns.PAN_PATTERN;
  public panOnInput = InputPatterns.PAN_ONINPUT;
  @Output() childCallbackSender = new EventEmitter<string>();

  @Output() childCallbackRelationship = new EventEmitter<string>();
  public viewLocalFileUtils: ViewLocalFileUtils = new ViewLocalFileUtils();


  constructor(private _coreSidebarService: CoreSidebarService,
    public relationshipService: RelationshipService,
    public updateProfileService: UpdateProfileService,
    private toast: ToastrService,
    public router: Router) {
    this.getSessionData();
  }

  ngOnInit(): void {
    this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
    this.getRelationshipMemberList();
  }

  getSessionData() {
    var getActiveOrderData = sessionStorage.getItem(ConstantsKey.SS_ACTIVE_ORDER);    
    if (getActiveOrderData) {
      this.stepperDataModel = JSON.parse(getActiveOrderData);
    } else {
      this.router.navigate(['/home'])
      .then(() => {
      window.location.reload();
       });
    }
  }

  public fileList: FileList;
  public fileRelationPan: File;
  public panSelected: boolean = false;

  addRelation(data) {
    if (this.panSelected && data === true) {
      this.addRelationshipModel.nationality = 'INDIAN';
      this.addRelationshipModel.consumerId = this.consumerId;
      let localPaxCreateRequests: Array<AddRelationshipModel> = [];
      localPaxCreateRequests.push(this.addRelationshipModel);
      let paxCreateRequests = { "paxCreateRequests": localPaxCreateRequests };

      this.relationshipService.addRelationship(paxCreateRequests).subscribe(async resp => {

        //upload document
        var response: any = resp.body;
        let relationShipID = response.id;
        await this.uploadPanCardDocument(relationShipID);

        this.getRelationshipMemberList();
        this.toast.success("Relationship added successfully", "Success !!");
        this.showAddRelationForm = false;
        this.addRelationshipModel.pan = '';
        this.addRelationshipModel.name = '';
        this.addRelationshipModel.relationship = '';
        this.childCallbackRelationship.emit('REFRESH_DATA');

      }, error => {
        this.toast.error(error.error.message);
      });
    } else {
      this.toast.error("Please select valid file!");

    }
  }

  hideAddRelation() {
    this.showAddRelationForm = false;
    this.addRelationshipModel.relationship = '';
    this.addRelationshipModel.pan = '';
    this.addRelationshipModel.name = '';
  }

  fileUploadPaxDocument(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.fileRelationPan = this.fileList[0];
      if (this.fileRelationPan.type.indexOf("pdf") >= 0 || this.fileRelationPan.type.indexOf("image") >= 0) {
        this.panSelected = true;
      }
    }
  }

  downloadUploadedDoc(){
    this.viewLocalFileUtils.viewLocalDocument(this.fileRelationPan);
  }

  async uploadPanCardDocument(relationShipID) {
    const formData = new FormData();
    formData.append('file', this.fileRelationPan, this.fileRelationPan.name);
    formData.append('ownerType', "PAX");
    formData.append('type', 'PANCARD');
    formData.append('description', "");
    formData.append('ownerId', relationShipID);
    formData.append('documentPurpose', "KYC");
    const response = await this.updateProfileService.paxDocumentUploadUpdate(formData).toPromise();
  }

  getRelationshipMemberList() {
    this.relationshipService.getRelationshipList().subscribe(resp => {
      this.relationshipMemberListItems = resp.body;
    }, error => {
      this.toast.error(error.error.message);
    });
  }

  toggleSidebar(name): void {
    this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {});
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  updateSelectedStudentDetailsToSession(singleRelationship) {
    this.getSessionData();
    let step02Data = new Step02Data();
    if (this.stepperDataModel.step02Data) {
      step02Data = this.stepperDataModel.step02Data;
    }
    step02Data.selfResPaxItemSingle = singleRelationship;
    this.stepperDataModel.step02Data = step02Data;
    sessionStorage.setItem(ConstantsKey.SS_ACTIVE_ORDER, JSON.stringify(this.stepperDataModel));
    this.childCallbackRelationship.emit('RELATIONSHIP_DATA_ADDED');
  }

  alphabetsAndSpaceOnly(e): boolean {  // Accept only alphabets and spaces (for Name as per PAN)
    var regex = new RegExp(this.alphabetsSpacePattern);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  panOnly(e): boolean {  // Accept only valid PAN characters (uppercase letters and numbers)
    var regex = new RegExp("^[A-Z0-9]$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }
}
